// extracted by mini-css-extract-plugin
export default {"actions":"_actions_tZeYDQ","archive-btn":"_archive-btn_0Jgqzb"};